const lineChart = {
  options: {
    chart: {
      width: "100%",
      height: 350,
      type: "area",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },

    legend: {
      show: false,
    },

    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 3,
      curve: "smooth",
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.28,
        opacityTo: 0.04,
        stops: [0, 95, 100],
      },
    },
    grid: {
      borderColor: "rgba(74, 108, 95, 0.12)",
      strokeDashArray: 5,
      padding: {
        top: 6,
        right: 12,
        left: 2,
        bottom: 0,
      },
    },
    markers: {
      size: 4,
      strokeWidth: 0,
      hover: {
        size: 6,
      },
    },

    yaxis: {
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 600,
          colors: ["#6f847b"],
        },
      },
    },

    xaxis: {
      labels: {
        rotate: -45,
        hideOverlappingLabels: true,
        trim: true,
        style: {
          fontSize: "12px",
          fontWeight: 600,
          colors: [
            "#6f847b",
            "#6f847b",
            "#6f847b",
            "#6f847b",
            "#6f847b",
            "#6f847b",
            "#6f847b",
            "#6f847b",
            "#6f847b",
          ],
        },
      },
      categories: [
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
      ],
    },

    tooltip: {
      theme: "light",
      y: {
        formatter(val) {
          return val;
        },
      },
    },
  },
};

export default lineChart;
